import { Component, Input } from '@angular/core';
import { Conference } from '@core/models/conference.model';
import { QuestionSubmissionService } from '@core/services/question-submission/question-submission.service';
import { ActivityNextItem } from '@core/models/common/activity-next-item.model';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-single-live-card',
  templateUrl: './single-live-card.component.html',
  styleUrl: './single-live-card.component.css',
})
export class SingleLiveCardComponent {
  @Input() live?: Conference;
  @Input() is_myLive: boolean = false;

  nextItem: ActivityNextItem | null = null;
  private subscriptions = new Subscription();

  constructor(
    private readonly questionSubmissionService: QuestionSubmissionService,
    private readonly router: Router
  ) {}

  startLive(liveUuid: string): void {
    const nextItemSub = this.questionSubmissionService.getConferenceNextItem(liveUuid).subscribe({
      next: (nextItem) => {
        this.nextItem = nextItem;
        if (!this.nextItem) return;

        if (this.nextItem.item_type === 'credit') {
          this.router.navigate([`/credit/${liveUuid}`]);
        } else if (this.nextItem.item_type === 'questionSet') {
          this.router.navigate([`/credit/${liveUuid}/test/${this.nextItem.item_uuid}`]);
        } else if (this.nextItem.item_type === 'certificate') {
          this.router.navigate([`/live/${liveUuid}/certificate`]);
        } else if (this.nextItem.item_type === 'certified') {
          if (this.nextItem.item_uuid) {
            window.open(this.nextItem.item_uuid, '_blank');
          }
        }
      },
      error: () => {
        this.nextItem = null;
      },
    });
    this.subscriptions.add(nextItemSub);
  }

  isExpiringSoon(expiredAt: string | null | undefined): boolean {
    if (!expiredAt) return false;
    const expiryDate = new Date(expiredAt).getTime();
    const now = Date.now();
    const diffInDays = (expiryDate - now) / (1000 * 60 * 60 * 24);
    return diffInDays >= 0 && diffInDays <= 30;
  }

  formatDate(date?: string | null): string {
    if (!date) return 'N/A';

    const normalized = date.includes('T') ? date : date + 'T00:00:00';
    const d = new Date(normalized);

    return d.toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'long',
      year: 'numeric',
    });
  }

  shouldShowButton(): boolean {
    if (!this.live) return false;

    const isCompleted = this.live?.participations?.[0]?.progress === 100;
    const isExpired =
      this.live?.expiration_date && new Date(this.live.expiration_date).getTime() < Date.now();

    if (this.is_myLive && (isCompleted || isExpired)) {
      return false;
    }

    return true;
  }
}
